import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'
import { useStoryStore } from '@/features/shared/stores/story.store'

export function StEditorInstancePlugin() {
    const [editor] = useLexicalComposerContext()
    const { setEditor } = useStoryStore()

    useEffect(() => {
        setEditor(editor)
        editor.focus()
    }, [editor])

    return null
}
